import { Registration } from '@/types/registration.types';

export default function resolveAutomaticSSOLoginToggle(settings: Registration | undefined): boolean {
  return settings?.singleSignOn?.automaticSSOLogin === true;
}
